import { render, staticRenderFns } from "./GridDetailSetting.vue?vue&type=template&id=2a64832c&scoped=true"
import script from "./GridDetailSetting.vue?vue&type=script&lang=js"
export * from "./GridDetailSetting.vue?vue&type=script&lang=js"
import style0 from "./GridDetailSetting.vue?vue&type=style&index=0&id=2a64832c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64832c",
  null
  
)

export default component.exports